import { useEffect, useState } from "react";
import axios from "axios";
import Key from "../../../../clientVariables.json";

const ZohoCallback = () => {
  const [params, setParams] = useState(null);
  const [step, setStep] = useState("verify"); // 'verify', 'authenticating', 'success', 'error'
  const [activeEmail, setActiveEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");
    const accountsServer = urlParams.get("accounts-server");

    if (code) {
      setParams({ code, state, accountsServer });
    }
  }, []);

  const handleReauthenticate = () => {
    if (!params) return;
    const { state } = params;

    const CLIENT_ID = "1000.4OII743C9WQ1SSD0B2WZXEUE38X1YK";
    const REDIRECT_URI = "http://bs.jobsnprofiles.com/zoho/callback";
    //const REDIRECT_URI = "http://localhost:5050/zoho/callback";

    const authUrl = `https://accounts.zoho.com/oauth/v2/auth`
      + `?scope=ZohoMail.messages.CREATE,ZohoMail.accounts.READ,profile,AaaServer.profile.Read`
      + `&client_id=${CLIENT_ID}`
      + `&response_type=code`
      + `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`
      + `&state=${state}`
      + `&access_type=offline`
      + `&prompt=login`;

    //console.log("[ZohoCallback] Restarting OAuth flow:", authUrl);
    window.location.href = authUrl;
  };

  const handleAuthenticate = () => {
    if (!params) return;
    setStep("authenticating");

    const { code, state, accountsServer } = params;

    // Parse state details
    let decoded = {};
    try { decoded = JSON.parse(atob(state)); } catch (e) { }

    const candidateId = decoded.candidateId;
    const jobId = decoded.jobId;
    const isPopup = window.opener && !window.opener.closed;

    // console.log("candidateId", candidateId);
    // console.log("jobId", jobId);
    // console.log("isPopup", isPopup);

    const REDIRECT_URI = "http://bs.jobsnprofiles.com/zoho/callback";
    //const REDIRECT_URI = "http://localhost:5050/zoho/callback";

    // Backend exchanges code, fetches token details
    axios.post(`${Key.domain}/mail/zoho/token`, { code, accountsServer, redirectUri: REDIRECT_URI })
      .then(async (res) => {
        const token = res.data.access_token;
        if (!token) {
          throw new Error("No access token returned from exchange");
        }

        let email = "";

        // Try to fetch dynamically from Zoho's CORS-enabled UserInfo endpoint
        try {
          const baseUrl = accountsServer ? accountsServer.replace(/\/$/, "") : "https://accounts.zoho.com";
          // console.log(`[ZohoCallback] Fetching user info from: ${baseUrl}/oauth/user/info`);
          const infoRes = await axios.get(`${baseUrl}/oauth/user/info`, {
            headers: { Authorization: `Zoho-oauthtoken ${token}` }
          });
          if (infoRes.data && infoRes.data.Email) {
            email = infoRes.data.Email;
            // console.log("[ZohoCallback] Dynamic email resolved:", email);
          }
        } catch (infoErr) {
          console.warn("[ZohoCallback] UserInfo fetch failed:", infoErr.message);
        }

        // Fallback to typed email address in storage
        if (!email) {
          email = sessionStorage.getItem("zoho_login_email") || localStorage.getItem("zoho_login_email");
          console.log("[ZohoCallback] Fallback stored email resolved:", email);
        }

        // Fallback to previously displayed email or placeholder
        if (!email || email === "undefined") {
          email = sessionStorage.getItem("zoho_email") || localStorage.getItem("zoho_email") || "authenticated_user";
        }

        //console.log("[ZohoCallback] Final authenticated email:", email);
        setActiveEmail(email);
        setStep("success");

        if (isPopup) {
          try {
            // Store email, token, and server in parent session storage
            window.opener.sessionStorage.setItem("zoho_email", email);
            window.opener.sessionStorage.setItem("zoho_token", token);
            window.opener.sessionStorage.setItem("zoho_accounts_server", accountsServer);

            const event = new window.opener.CustomEvent("zoho_auth_success", {
              detail: { email, token, accountsServer }
            });
            window.opener.dispatchEvent(event);
            //console.log("[ZohoCallback] Event fired on opener with email & token:", email);
          } catch (e) {
            console.warn("[ZohoCallback] opener error:", e);
          }
          setTimeout(() => window.close(), 1500);
        } else {
          // Fallback redirect
          localStorage.setItem("zoho_email", email);
          localStorage.setItem("zoho_token", token);
          localStorage.setItem("zoho_accounts_server", accountsServer);
          sessionStorage.setItem("zoho_redirect", "1");

          if (candidateId) {
            sessionStorage.setItem("target_candidate_id", candidateId);
            if (jobId) {
              sessionStorage.setItem("target_job_id", jobId);
            }
          }
          window.location.href = `/my-candidates`;
        }
      })
      .catch(err => {
        const errorDetail = err.response?.data?.error || err.message || "Failed to exchange authorization details";
        console.error("[ZohoCallback] Failed:", errorDetail);
        setErrorMessage(errorDetail);
        setStep("error");
      });
  };

  const accountsPage = params && params.accountsServer && params.accountsServer.includes("zoho.in")
    ? "https://accounts.zoho.in/home#profile/personal"
    : "https://accounts.zoho.com/home#profile/personal";

  return (
    <div style={{
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      padding: "40px 20px",
      textAlign: "center",
      color: "#333",
      backgroundColor: "#f4f6f8",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      boxSizing: "border-box"
    }}>
      <div style={{
        backgroundColor: "#ffffff",
        padding: "35px 30px",
        borderRadius: "12px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
        maxWidth: "460px",
        width: "100%"
      }}>

        {step === "verify" && (
          <>
            <div style={{ fontSize: "24px", fontWeight: "700", color: "#1e88e5", marginBottom: "10px" }}>
              Confirm Zoho Account
            </div>

            <div style={{
              fontSize: "13.5px",
              lineHeight: "1.6",
              color: "#333",
              fontWeight: "500",
              marginBottom: "25px",
              backgroundColor: "#f5f7f8",
              padding: "15px",
              borderRadius: "8px",
              textAlign: "left",
              borderLeft: "4px solid #1e88e5"
            }}>
              Please verify if the correct user is logged in to Zoho in your browser before you authenticate.
            </div>

            {/* Step 1 */}
            <div style={{ textAlign: "left", marginBottom: "25px" }}>
              <div style={{ fontSize: "14px", fontWeight: "700", color: "#455a64", marginBottom: "8px" }}>
                1. Check Logged-in Session
              </div>
              <div style={{ fontSize: "12.5px", color: "#666", lineHeight: "1.5", marginBottom: "12px" }}>
                Opens your current Zoho accounts profile in a new tab so you can confirm or sign out if needed.
              </div>
              <a
                href={accountsPage}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "block",
                  textAlign: "center",
                  textDecoration: "none",
                  backgroundColor: "#ffffff",
                  color: "#1e88e5",
                  border: "1.5px solid #1e88e5",
                  borderRadius: "6px",
                  padding: "10px 20px",
                  fontSize: "13.5px",
                  fontWeight: "600",
                  cursor: "pointer",
                  width: "100%",
                  boxSizing: "border-box",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#1e88e5";
                  e.currentTarget.style.color = "#ffffff";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#ffffff";
                  e.currentTarget.style.color = "#1e88e5";
                }}
              >
                Check Logged-in Account
              </a>
            </div>

            {/* Step 2 */}
            <div style={{ textAlign: "left", marginBottom: "10px" }}>
              <div style={{ fontSize: "14px", fontWeight: "700", color: "#455a64", marginBottom: "8px" }}>
                2. Authenticate Zoho Integration
              </div>
              <div style={{ fontSize: "12.5px", color: "#666", lineHeight: "1.5", marginBottom: "12px" }}>
                Proceed only if the correct user is active. This will save the credentials and link the account.
              </div>
              <button
                onClick={handleAuthenticate}
                style={{
                  backgroundColor: "#4caf50",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "12px 20px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  width: "100%",
                  boxShadow: "0 4px 12px rgba(76,175,80,0.3)",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#388e3c"}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#4caf50"}
              >
                Authenticate If Correct User
              </button>
            </div>

            {/* Re-authenticate */}
            <div style={{ textAlign: "left", marginTop: "20px", borderTop: "1px dashed #cfd8dc", paddingTop: "20px" }}>
              <div style={{ fontSize: "14px", fontWeight: "700", color: "#455a64", marginBottom: "8px" }}>
                Need to Switch Accounts?
              </div>
              <div style={{ fontSize: "12.5px", color: "#666", lineHeight: "1.5", marginBottom: "12px" }}>
                If the correct user is not logged in, logout from Zoho in the other tab and click below to re-authenticate again.
              </div>
              <button
                onClick={handleReauthenticate}
                style={{
                  backgroundColor: "#ffffff",
                  color: "#e65100",
                  border: "1.5px solid #ff9800",
                  borderRadius: "6px",
                  padding: "10px 20px",
                  fontSize: "13.5px",
                  fontWeight: "600",
                  cursor: "pointer",
                  width: "100%",
                  transition: "all 0.2s ease"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#ff9800";
                  e.currentTarget.style.color = "#ffffff";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#ffffff";
                  e.currentTarget.style.color = "#e65100";
                }}
              >
                Re-Authenticate
              </button>
            </div>
          </>
        )}

        {step === "authenticating" && (
          <>
            <div style={{ fontSize: "22px", fontWeight: "700", color: "#1e88e5", marginBottom: "15px" }}>
              Authenticating...
            </div>
            <div style={{ margin: "25px 0" }}>
              <div style={{
                border: "4px solid #f3f3f3",
                borderTop: "4px solid #1e88e5",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite",
                margin: "0 auto"
              }} />
              <style>{`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}</style>
            </div>
            <div style={{ fontSize: "14px", color: "#666", lineHeight: "1.5" }}>
              Exchanging secure credentials with Zoho Mail API.
              <br />
              Please do not close this window.
            </div>
          </>
        )}

        {step === "success" && (
          <>
            <div style={{ fontSize: "24px", fontWeight: "700", color: "#4caf50", marginBottom: "15px" }}>
              ✓ Success!
            </div>
            <div style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#388e3c",
              backgroundColor: "#e8f5e9",
              padding: "12px",
              borderRadius: "6px",
              marginBottom: "20px"
            }}>
              Authenticated as: {activeEmail}
            </div>
            <div style={{ fontSize: "13px", color: "#666" }}>
              Your Zoho session is successfully linked. Closing this window now...
            </div>
          </>
        )}

        {step === "error" && (
          <>
            <div style={{ fontSize: "24px", fontWeight: "700", color: "#f44336", marginBottom: "15px" }}>
              Authentication Failed
            </div>
            <div style={{
              fontSize: "13px",
              lineHeight: "1.6",
              color: "#d32f2f",
              backgroundColor: "#ffebee",
              padding: "12px",
              borderRadius: "6px",
              marginBottom: "20px"
            }}>
              {errorMessage}
            </div>
            <button
              onClick={() => setStep("verify")}
              style={{
                backgroundColor: "#78909c",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                padding: "10px 20px",
                fontSize: "13px",
                fontWeight: "600",
                cursor: "pointer",
                width: "100%",
                transition: "all 0.2s ease"
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#546e7a"}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#78909c"}
            >
              Go Back
            </button>
          </>
        )}

      </div>
    </div>
  );
};

export default ZohoCallback;